/* eslint-disable react/no-array-index-key */
import {
    Box,
    Button,
    Menu, MenuButton, MenuItem, MenuList,
    useTabsContext,
} from '@chakra-ui/react';
import { faAngleDown, faCheck } from '@fortawesome/pro-solid-svg-icons';
import { ComponentProps } from 'react';
import { FaIcon } from '../fa-icon';

export function TabDropdown({
    items,
    ...props
}: {
    items: React.ReactNode[];
} & ComponentProps<typeof Button>) {
    const tabContext = useTabsContext();
    return (
        <Menu matchWidth>
            <MenuButton
                as={Button}
                variant="outline"
                colorScheme="gray"
                rightIcon={<FaIcon icon={faAngleDown} />}
                w="100%"
                textAlign="left"
                {...props}
            >
                {items[tabContext.selectedIndex]}
            </MenuButton>
            <MenuList w="100%">
                {
                    items.map((item, index) => (
                        <MenuItem
                            key={index}
                            onClick={() => tabContext.setSelectedIndex(index)}
                        >
                            <Box flexGrow={1} fontWeight={index === tabContext.selectedIndex ? 'medium' : 'normal'}>
                                {item}
                            </Box>
                            { index === tabContext.selectedIndex && (
                                <FaIcon icon={faCheck} ml={2} h={3} />
                            )}
                        </MenuItem>
                    ))
                }
            </MenuList>
        </Menu>
    );
}
